import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateListResource } from '../../../../lib/query/invalidateResource';
import { notification } from 'antd';
import { updateCustomerSegment } from '../api/customerSegments';
import type { CustomerSegmentFormValues } from '../types';

export function useUpdateCustomerSegment(segmentId: string | null, onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CustomerSegmentFormValues) => {
      if (segmentId === null) {
        throw new Error('Segment id is required');
      }
      return updateCustomerSegment(segmentId, data);
    },
    onSuccess: () => {
      notification.success({ message: 'Customer segment updated successfully' });
      invalidateListResource(queryClient, 'customer-segments');
      void queryClient.invalidateQueries({ queryKey: ['settings-contact-categories'] });
      void queryClient.invalidateQueries({ queryKey: ['contact-categories'] });
      onSuccess?.();
    },
    onError: () => {
      notification.error({ message: 'Failed to update customer segment' });
    },
  });
}
